module.exports = __webpack_public_path__ + "img/01775f3.png";